import elvenSyndicatePreview from '../assets/elven-syndicate-preview.png';
export const skills = [
	{
		title: 'Frontend',
		skills: [
			{
				name: 'HTML',
				image: 'https://www.w3.org/html/logo/badge/html5-badge-h-solo.png',
			},
			{
				name: 'CSS',
				image:
					'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png',
			},
			{
				name: 'Scss',
				image: 'skills/sass.svg',
			},
			{
				name: 'Bootstrap',
				image: 'https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png',
			},

			{
				name: 'JavaScript',
				image:
					'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png',
			},

			{
				name: 'React',
				image:
					'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K',
			},
			{
				name: 'Redux',
				image: 'skills/redux.svg',
			},
		],
	},
	{
		title: 'Backend',
		skills: [
			{
				name: 'Node Js',
				image: 'https://nodejs.org/static/images/logo.svg',
			},

			{
				name: 'PHP',
				image: 'skills/php.svg',
			},
			{
				name: 'MySQL',
				image:
					'https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg',
			},
		],
	},

	{
		title: 'Others',
		skills: [
			{
				name: 'Git',
				image:
					'https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667',
			},
			{
				name: 'GitHub',
				image: 'https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png',
			},

			{
				name: 'VS Code',
				image:
					'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519',
			},
			{
				name: 'Gulp',
				image: 'skills/gulp.svg',
			},
			{
				name: 'Adobe PS',
				image: 'skills/Ps.svg',
			},
			{
				name: 'Adobe XD',
				image:
					'https://camo.githubusercontent.com/c205ecbe12500177d102169d97bc1c17c545155fdf5ec78c08d54ac53e5b38c1/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f61646f62652d78642e737667',
			},
			{
				name: 'Figma',
				image:
					'https://camo.githubusercontent.com/ed93c2b000a76ceaad1503e7eb9356591b885227e82a36a005b9d3498b303ba5/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6669676d612f6669676d612d69636f6e2e737667',
			},
		],
	},
];

export const projects = [
	{
		id: 111,
		title: 'Chaikhana Restaurant',
		dateEng: 'May 2026',
		dateRu: 'Май 2026',
		descriptionEng: 'A premium restaurant website for an eastern cuisine venue with menu filters, booking flow, reviews, offers, gallery, map, Telegram/WhatsApp actions and mobile-first layout.',
		descriptionRu: 'Премиальный сайт ресторана восточной кухни: меню с фильтрами, бронь столика, отзывы, акции, галерея, карта, Telegram/WhatsApp-заявки и удобная мобильная версия.',
		image: 'projects/chaikhana-restaurant-preview.svg',
		tags: ['React', 'TypeScript', 'Vite', 'Restaurant UI', 'Booking', 'Responsive'],
		category: 'landing',
		github: 'https://github.com/kenform/chaikhana-demo',
		webapp: 'https://chaikhana-demo.vercel.app/',
	},
	{
		id: 110,
		title: "BookingFlow AI",
		category: "landing",
		typeEng: 'AI-ready booking website',
		typeRu: 'AI-ready сайт записи',
		type: 'AI-ready booking website',
		textEng: 'AI-ready booking website demo: online booking flow, service cards, time slots, AI booking assistant, prepared booking brief and mobile-first frontend demo.',
		textRu: 'AI-ready booking website демо-проект: онлайн-запись, карточки услуг, свободные слоты, AI booking assistant, prepared booking brief и mobile-first frontend demo.',
		demoLink: "https://bookingflow-ai.vercel.app/",
		websiteUrl: "https://bookingflow-ai.vercel.app/",
		websiteLink: "https://bookingflow-ai.vercel.app/",
		githubLink: "https://github.com/kenform/bookingflow-ai",
    technologies: ["React", "TypeScript", "Vite", "Tailwind", "Booking", "AI-ready"],
    sourceUrl: "https://github.com/kenform/bookingflow-ai",
    codeUrl: "https://github.com/kenform/bookingflow-ai",
    repoUrl: "https://github.com/kenform/bookingflow-ai",
    githubUrl: "https://github.com/kenform/bookingflow-ai",
    previewUrl: "https://bookingflow-ai.vercel.app",
    siteUrl: "https://bookingflow-ai.vercel.app",
    demoUrl: "https://bookingflow-ai.vercel.app",
    liveUrl: "https://bookingflow-ai.vercel.app/",
    href: "https://bookingflow-ai.vercel.app/",
    url: "https://bookingflow-ai.vercel.app/",
    link: "https://bookingflow-ai.vercel.app",
    year: "Май 2026",
    date: "Май 2026",
    excerpt: "AI-ready booking website demo с каталогом, фильтрами, корзиной и быстрым подбором товаров.",
    short: "AI-ready booking website demo с каталогом, фильтрами, корзиной и быстрым подбором товаров.",
    shortDescription: "AI-ready booking website demo с каталогом, фильтрами, корзиной и быстрым подбором товаров.",
    about: "AI-ready сайт записи для услуг: услуги, свободные слоты, AI booking assistant, форма заявки, prepared booking brief и mobile-first интерфейс и понятный путь клиента до заявки.",
    summary: "AI-ready сайт записи для услуг: услуги, свободные слоты, AI booking assistant, форма заявки, prepared booking brief и mobile-first интерфейс и понятный путь клиента до заявки.",
    text: "AI-ready сайт записи для услуг: услуги, свободные слоты, AI booking assistant, форма заявки, prepared booking brief и mobile-first интерфейс и понятный путь клиента до заявки.",
    description: "AI-ready сайт записи для услуг: услуги, свободные слоты, AI booking assistant, форма заявки, prepared booking brief и mobile-first интерфейс и понятный путь клиента до заявки.",
    name: "BookingFlow AI",
		thumbnail: "projects/bookingflow-ai-preview.svg",
		thumb: "projects/bookingflow-ai-preview.svg",
		src: "projects/bookingflow-ai-preview.svg",
		dateEng: "May 2026",
		dateRu: "Май 2026",
		descriptionEng: 'AI-ready booking website demo: online booking flow, service cards, time slots, AI booking assistant, prepared booking brief and mobile-first frontend demo.',
		descriptionRu: "AI-ready сайт записи для услуг: услуги, свободные слоты, AI booking assistant, форма заявки, prepared booking brief и mobile-first интерфейс и понятный путь клиента до заявки.",
		img: "projects/bookingflow-ai-preview.svg",
		image: "projects/bookingflow-ai-preview.svg",
		imageUrl: "projects/bookingflow-ai-preview.svg",
		preview: "projects/bookingflow-ai-preview.svg",
		cover: "projects/bookingflow-ai-preview.svg",
		projectLink: "https://bookingflow-ai.vercel.app/",
		website: "https://bookingflow-ai.vercel.app/",
		webapp: "https://bookingflow-ai.vercel.app/",
		visit: 'https://bookingflow-ai.vercel.app/',
		site: "https://bookingflow-ai.vercel.app",
		demo: "https://bookingflow-ai.vercel.app/",
		live: "https://bookingflow-ai.vercel.app/",
		codeLink: "https://github.com/kenform/bookingflow-ai",
		github: "https://github.com/kenform/bookingflow-ai",
		source: "https://github.com/kenform/bookingflow-ai",
		code: "https://github.com/kenform/bookingflow-ai",
		repo: "https://github.com/kenform/bookingflow-ai",
		stack: ["React", "TypeScript", "Vite", "Tailwind", "Booking", "AI-ready"],
		tags: ["React", "TypeScript", "Vite", "Tailwind", "Booking", "AI-ready"],
	},
{
		id: 108,
		title: "StorePilot AI",
		typeEng: 'AI-ready e-commerce',
		typeRu: 'AI-ready интернет-магазин',
		type: 'AI-ready e-commerce',
		textEng: 'AI-ready e-commerce demo: smart catalog, filters, AI product matching, cart flow, prepared order brief and lightweight frontend without heavy libraries.',
		textRu: 'AI-ready e-commerce демо-проект: smart catalog, фильтры, AI-подбор товаров, корзина, prepared order brief и лёгкий frontend без тяжёлых библиотек.',
		demoLink: 'https://storepilot-ai.vercel.app/',
		websiteUrl: 'https://storepilot-ai.vercel.app/',
		websiteLink: 'https://storepilot-ai.vercel.app/',
		githubLink: 'https://github.com/kenform/storepilot-ai',
    technologies: ["React", "TypeScript", "Vite", "Tailwind", "E-commerce", "AI-ready"],
    sourceUrl: 'https://github.com/kenform/storepilot-ai',
    codeUrl: "https://github.com/kenform/storepilot-ai",
    repoUrl: 'https://github.com/kenform/storepilot-ai',
    githubUrl: 'https://github.com/kenform/storepilot-ai',
    previewUrl: "https://storepilot-ai.vercel.app",
    siteUrl: "https://storepilot-ai.vercel.app",
    demoUrl: "https://storepilot-ai.vercel.app",
    liveUrl: 'https://storepilot-ai.vercel.app/',
    href: 'https://storepilot-ai.vercel.app/',
    url: 'https://storepilot-ai.vercel.app/',
    link: "https://storepilot-ai.vercel.app",
    year: "Май 2026",
    date: "Май 2026",
    excerpt: "AI-ready e-commerce demo с каталогом, фильтрами, корзиной и быстрым подбором товаров.",
    short: "AI-ready e-commerce demo с каталогом, фильтрами, корзиной и быстрым подбором товаров.",
    shortDescription: "AI-ready e-commerce demo с каталогом, фильтрами, корзиной и быстрым подбором товаров.",
    about: "AI-ready e-commerce demo: витрина товаров, фильтры, корзина, AI-подбор и подготовленное сообщение для менеджера. Лёгкий быстрый сайт на Vite/React с отдельным favicon и mobile-first адаптивом.",
    summary: "AI-ready e-commerce demo: витрина товаров, фильтры, корзина, AI-подбор и подготовленное сообщение для менеджера. Лёгкий быстрый сайт на Vite/React с отдельным favicon и mobile-first адаптивом.",
    text: 'AI-ready e-commerce демо-проект: smart catalog, фильтры, AI-подбор товаров, корзина, prepared order brief и лёгкий frontend без тяжёлых библиотек.',
    description: 'AI-ready e-commerce демо-проект: smart catalog, фильтры, AI-подбор товаров, корзина, prepared order brief и лёгкий frontend без тяжёлых библиотек.',
    name: "StorePilot AI",
		thumbnail: "projects/storepilot-ai-preview.svg",
		thumb: "projects/storepilot-ai-preview.svg",
		src: "projects/storepilot-ai-preview.svg",
		dateEng: 'May 2026',
		dateRu: 'Май 2026',
		descriptionEng: 'AI-ready e-commerce demo: smart catalog, filters, AI product matching, cart flow, prepared order brief and lightweight frontend without heavy libraries.',
		descriptionRu: 'AI-ready e-commerce демо-проект: smart catalog, фильтры, AI-подбор товаров, корзина, prepared order brief и лёгкий frontend без тяжёлых библиотек.',
		img: "projects/storepilot-ai-preview.svg",
		image: "projects/storepilot-ai-preview.svg",
		imageUrl: "projects/storepilot-ai-preview.svg",
		preview: "projects/storepilot-ai-preview.svg",
		cover: "projects/storepilot-ai-preview.svg",
		projectLink: 'https://clientflow-crm-steel.vercel.app/',
		website: 'https://storepilot-ai.vercel.app/',
		webapp: 'https://storepilot-ai.vercel.app/',
		visit: 'https://clientflow-crm-steel.vercel.app/',
		site: "https://storepilot-ai.vercel.app",
		demo: 'https://storepilot-ai.vercel.app/',
		live: 'https://storepilot-ai.vercel.app/',
		codeLink: 'https://github.com/kenform/storepilot-ai',
		github: 'https://github.com/kenform/storepilot-ai',
		source: "https://github.com/kenform/storepilot-ai",
		code: 'https://github.com/kenform/storepilot-ai',
		repo: 'https://github.com/kenform/storepilot-ai',
		stack: ["React", "TypeScript", "Vite", "Tailwind", "E-commerce", "AI-ready"],
		tags: ["React", "TypeScript", "Vite", "Tailwind", "E-commerce", "AI-ready"],
	},
{
		id: 108,
		title: 'ClientFlow CRM',
		thumbnail: 'projects/clientflow-crm-preview.png',
		thumb: 'projects/clientflow-crm-preview.png',
		src: 'projects/clientflow-crm-preview.png',
		dateEng: 'May 2026',
		dateRu: 'Май 2026',
		descriptionEng: 'A lightweight SaaS CRM dashboard for website, Telegram and AI assistant leads: lead inbox, AI summaries, pipeline, analytics, activity feed and brief builder.',
		descriptionRu: 'Лёгкая SaaS/CRM-панель для заявок с сайта, Telegram и AI-помощника: inbox лидов, AI summary, pipeline, аналитика, activity feed и brief-builder.',
		img: 'projects/clientflow-crm-preview.png',
		image: 'projects/clientflow-crm-preview.png',
		imageUrl: 'projects/clientflow-crm-preview.png',
		preview: 'projects/clientflow-crm-preview.png',
		cover: 'projects/clientflow-crm-preview.png',
		projectLink: 'https://clientflow-crm-steel.vercel.app/',
		website: 'https://clientflow-crm-steel.vercel.app/',
		webapp: 'https://clientflow-crm-steel.vercel.app/',
		visit: 'https://clientflow-crm-steel.vercel.app/',
		site: 'https://clientflow-crm-steel.vercel.app/',
		demo: 'https://clientflow-crm-steel.vercel.app/',
		live: 'https://clientflow-crm-steel.vercel.app/',
		codeLink: 'https://github.com/kenform/clientflow-crm',
		github: 'https://github.com/kenform/clientflow-crm',
		source: 'https://github.com/kenform/clientflow-crm',
		code: 'https://github.com/kenform/clientflow-crm',
		repo: 'https://github.com/kenform/clientflow-crm',
		stack: ['React', 'TypeScript', 'Vite', 'Tailwind', 'CRM', 'AI-ready'],
		tags: ['React', 'TypeScript', 'Vite', 'Tailwind', 'CRM', 'AI-ready'],
	},
	{
		id: 107,
		title: 'RenovaFlow',
		dateEng: 'May 2026',
		dateRu: 'Май 2026',
		descriptionEng: "A premium AI-ready website for a renovation studio: service structure, lead quiz, renovation brief assistant, Telegram handoff, process blocks, trust elements and warm interior-style visual system.",
		descriptionRu: "Премиальный AI-ready сайт для студии ремонта: структура услуг, квиз заявки, помощник для подготовки brief, передача в Telegram, процесс, блоки доверия и тёплая интерьерная визуальная система.",
		image: 'projects/renovaflow-interior.svg',
		tags: ['React', 'TypeScript', 'Vite', 'Tailwind', 'AI-ready', 'Telegram', 'Lead Quiz', 'Business Website'],
		category: 'business',
		github: "https://github.com/kenform/renovaflow",
		webapp: "https://renovaflow.vercel.app/",
	},
	
{
    photos: [elvenSyndicatePreview],
    cardImages: [elvenSyndicatePreview],
    modalImages: [elvenSyndicatePreview],
    previewImages: [elvenSyndicatePreview],
    slides: [elvenSyndicatePreview],
    gallery: [elvenSyndicatePreview],
    screenshots: [elvenSyndicatePreview],
    pictures: [elvenSyndicatePreview],
    images: [elvenSyndicatePreview],
    poster: elvenSyndicatePreview,
    stack: ["React", "TypeScript", "Vite", "Tailwind", "Vercel", "AI", "Telegram"],
    technology: ["React", "TypeScript", "Vite", "Tailwind", "Vercel", "AI", "Telegram"],
    technologies: ["React", "TypeScript", "Vite", "Tailwind", "Vercel", "AI", "Telegram"],
    src: elvenSyndicatePreview,
    cardImage: elvenSyndicatePreview,
    modalImage: elvenSyndicatePreview,
    mainImage: elvenSyndicatePreview,
    photo: elvenSyndicatePreview,
    projectImg: elvenSyndicatePreview,
    projectImage: elvenSyndicatePreview,
    picture: elvenSyndicatePreview,
    cover: elvenSyndicatePreview,
    thumbnail: elvenSyndicatePreview,
    preview: elvenSyndicatePreview,
    imageSrc: elvenSyndicatePreview,
    imageUrl: elvenSyndicatePreview,
    imgUrl: elvenSyndicatePreview,
    img: elvenSyndicatePreview,
    demo: `https://elven-syndicate.vercel.app/`,
    link: `https://elven-syndicate.vercel.app/`,
    text: `Fantasy-tech сайт для Web & AI студии с AI-assistant demo, Telegram-first flow, RU/EN, адаптивом и деплоем на Vercel.`,
    description: `Премиальный fantasy-tech сайт для Web & AI студии: React, TypeScript, Vite, Tailwind, RU/EN, AI-assistant demo, Telegram-first flow, адаптивная мобильная версия и деплой на Vercel.`,
    name: `Elven Syndicate`,
		id: 106,
		title: "Elven Syndicate",
		dateEng: 'May 2026',
		dateRu: 'Май 2026',
		descriptionEng: "A real client website for the Elven Syndicate project. I polished the structure, responsive layout, SEO basics, service sections, pricing, specialists and contact flow so the page feels calm, clear and trustworthy.",
		descriptionRu: "Реальный заказной сайт для проекта Elven Syndicate. Я доработал структуру, адаптив, базовое SEO, блоки услуг, цены, специалистов и контакты, чтобы сайт выглядел спокойно, понятно и вызывал доверие.",
		image: elvenSyndicatePreview,
		tags: ["React", "TypeScript", "Vite", "Tailwind", "Vercel", "AI", "Telegram"],
		category: 'Web & AI Studio',
		github: "https://github.com/kenform/elven-syndicate",
		webapp: "https://elven-syndicate.vercel.app/",
	},

	{
		id: 7,
		title: "VitaPulse",
		dateEng: 'May 2026',
		dateRu: 'Май 2026',
		descriptionEng: "A real client website for the VitaPulse project. I polished the structure, responsive layout, SEO basics, service sections, pricing, specialists and contact flow so the page feels calm, clear and trustworthy.",
		descriptionRu: "Реальный заказной сайт для проекта VitaPulse. Я доработал структуру, адаптив, базовое SEO, блоки услуг, цены, специалистов и контакты, чтобы сайт выглядел спокойно, понятно и вызывал доверие.",
		image: 'projects/vitapulse-clinic.svg',
		tags: ['HTML', 'CSS', 'JavaScript', 'Medical UI', 'Responsive', 'UI/UX Polish'],
		category: 'landing',
		github: "https://github.com/kenform/VitaPulse",
		webapp: "https://fagot-h0ostr9ig-kenformgod-6184s-projects.vercel.app/",
	},
	{
		id: 1,
		title: 'React Pizza',
		dateEng: 'Aug 2023',
		dateRu: 'Авг 2023',
		descriptionEng: "A React pizza store with catalog, search, filters, sorting, pagination, product pages and cart logic. The project was polished for GitHub Pages with metadata, documentation and a cleaner deployment setup.",
		descriptionRu: "React-магазин пиццы с каталогом, поиском, фильтрами, сортировкой, пагинацией, страницами товаров и корзиной. Проект доведён для GitHub Pages: обновлены метаданные, документация и деплой.",
		image: 'projects/07.jpg',
		tags: [
			'React Js 18',
			'Redux Toolkit',
			'TypeScript',
			'React Router v6',
			'mockap.io',
			'Axios + Fetch',
			'Scss',
			'Html',
		],
		category: 'store',
		github: "https://github.com/kenform/react-pizza",
		webapp: "https://react-pizza-xi-nine.vercel.app",
	},
	{
		id: 2,
		title: 'React Sneakers',
		dateEng: 'Aug 2023',
		dateRu: 'Авг 2023',
		descriptionEng: "A React sneaker store with product catalog, favorites, cart, orders and fallback data when the API is unavailable. The project was polished for GitHub Pages, documentation and stable mobile usage.",
		descriptionRu: "React-магазин кроссовок с каталогом, избранным, корзиной, заказами и fallback-данными на случай недоступности API. Проект доведён для GitHub Pages, документации и стабильной работы на мобильных.",
		image: 'projects/01.jpg',
		tags: ['React Js', 'SCSS', 'Store', 'Cart', 'Favorites', 'Responsive', 'UI/UX Polish'],
		category: 'store',
		github: "https://github.com/kenform/react-sneakers",
		webapp: "https://react-sneakers-beta-gray.vercel.app",
	},
	{
		id: 4,
		title: 'Tzeezotje Restaurant',
		dateEng: 'May 2026',
		dateRu: 'Май 2026',
		descriptionEng: "A restaurant landing page with a strong visual hero, menu highlights, events, reviews and contacts. The project was polished with fixed favicon, SEO metadata, sitemap and image loading improvements.",
		descriptionRu: "Лендинг ресторана с выразительным первым экраном, меню, событиями, отзывами и контактами. Доработаны favicon, SEO-метаданные, sitemap и оптимизация загрузки изображений.",
		image: 'projects/tzeezotje-restaurant.svg',
		tags: ['HTML', 'SCSS', 'JavaScript', 'Gulp', 'Restaurant UI', 'Responsive', 'UI/UX Polish'],
		category: 'landing',
		github: "https://github.com/kenform/Tzeezotje",
		webapp: "https://kenform.github.io/Tzeezotje/",
	},
	{
		id: 3,
		title: 'FarmVest',
		dateEng: 'Aug 2023',
		dateRu: 'Авг 2023',
		descriptionEng: "A responsive landing page for a smart farm investing product. I polished SEO basics, metadata, image loading, documentation and the overall technical readiness of the page.",
		descriptionRu: "Адаптивный лендинг для продукта про инвестиции в фермерство. Я доработал базовое SEO, метаданные, загрузку изображений, документацию и техническую готовность страницы.",
		image: 'projects/02.jpg',
		tags: ['Html', 'Scss', 'Javascript', 'Gulp'],
		category: 'landing',
		github: "https://github.com/kenform/FarmVest",
		webapp: "https://kenform.github.io/FarmVest/",
	},
	{
		id: 6,
		title: 'Britlex',
		dateEng: 'Mar 2022',
		dateRu: 'Март 2022',
		descriptionEng: "A clean responsive language school landing page with hero, skills, about, pricing and contact sections. The project was polished with SEO metadata, sitemap, README and image loading improvements.",
		descriptionRu: "Чистый адаптивный лендинг языковой школы с первым экраном, навыками, блоком о школе, ценами и контактами. Доработаны SEO-метаданные, sitemap, README и загрузка изображений.",
		image: 'projects/04.jpg',
		tags: ['Html', 'Scss', 'Javascript', 'Gulp'],
		category: 'landing',
		github: "https://github.com/kenform/Britlex",
		webapp: "https://kenform.github.io/Britlex/",
	},
	{
		id: 5,
		title: 'Biysk',
		dateEng: 'Sept 2023',
		dateRu: 'Сент 2023',
		descriptionEng: "A responsive city promo landing page about Biysk with a bold hero, adaptive mobile layout, clean sections, apartment cards, contact form and polished visual structure.",
		descriptionRu: "Адаптивный промо-лендинг о Бийске с крупным первым экраном, мобильной адаптацией, аккуратными секциями, карточками квартир, контактной формой и доработанной визуальной структурой.",
		image: 'projects/08.jpg',
		tags: ['Html', 'Scss', 'Javascript', 'Gulp', 'Swiper'],
		category: 'landing',
		github: "https://github.com/kenform/Biysk",
		webapp: "https://biysk-pi.vercel.app/",
	},
	{
		id: 105,
		title: 'Birthday Greeting Site',
		dateEng: 'May 2026',
		dateRu: 'Май 2026',
		descriptionEng: "A warm birthday microsite with random greeting variants, soft animations and a responsive layout. Built as a lightweight personal page that can be shared as a digital greeting card.",
		descriptionRu: "Тёплый сайт-поздравление с вариантами пожеланий, мягкими анимациями и адаптивной вёрсткой. Небольшая персональная страница, которую можно отправлять как цифровую открытку.",
		image: 'projects/birthday-greeting-site.svg',
		tags: ['React', 'Vite', 'Tailwind CSS', 'Greeting Site', 'Random Content', 'Responsive'],
		category: 'landing',
		github: "https://github.com/kenform/birthday-greeting-site",
		webapp: "https://birthday-greeting-universal.vercel.app/",
	},
	{
		id: 103,
		title: 'Spring Greeting Site',
		dateEng: 'Mar 2026',
		dateRu: 'Март 2026',
		descriptionEng: "A seasonal greeting landing page with a light mood, simple structure and responsive design. The project focuses on emotion, atmosphere and a clean visual presentation.",
		descriptionRu: "Сезонный поздравительный лендинг с лёгким настроением, простой структурой и адаптивным дизайном. Акцент сделан на эмоции, атмосферу и чистую визуальную подачу.",
		image: 'projects/spring-greeting-site.svg',
		tags: ['Next.js', 'React', 'Tailwind CSS', 'Landing Page', 'Responsive'],
		category: 'landing',
		github: "https://github.com/kenform/spring-greeting-site",
		webapp: "https://spring-greeting-site.vercel.app",
	},
	{
		id: 104,
		title: 'Eragon Exchange',
		dateEng: 'May 2026',
		dateRu: 'Май 2026',
		descriptionEng: "A fantasy-styled exchange landing page with a dark visual mood, strong sections and responsive layout. The project works as a branded concept rather than a generic crypto page.",
		descriptionRu: "Fantasy-лендинг обменного сервиса с тёмной атмосферой, сильными секциями и адаптивной вёрсткой. Проект выглядит как брендовый концепт, а не обычная crypto-страница.",
		image: 'projects/eragon-exchange.svg',
		tags: ['Next.js', 'React', 'Landing Page', 'Crypto UI', 'Responsive'],
		category: 'landing',
		github: "https://github.com/kenform/-eragon-exchange-site-next",
		webapp: "https://eragon-exchange-site-next-kenformgod-6184s-projects.vercel.app",
	},
	{
		id: 101,
		title: 'BARBER Landing',
		dateEng: 'May 2026',
		dateRu: 'Май 2026',
		descriptionEng: "A premium barbershop landing page with services, masters, reviews, contacts and a clear booking direction. Built with a dark style and mobile-first layout.",
		descriptionRu: "Премиальный лендинг для барбершопа с услугами, мастерами, отзывами, контактами и понятным направлением к записи. Сделан в тёмном стиле с mobile-first подходом.",
		image: 'projects/barbershop-landing.svg',
		tags: ['React', 'Vite', 'Tailwind CSS', 'Landing Page', 'Responsive', 'UI Design'],
		category: 'landing',
		github: "https://github.com/kenform/barbershop-landing",
		webapp: "https://barbershop-landing-sable.vercel.app/",
	},
	{
		id: 102,
		title: 'Library Landing',
		dateEng: 'May 2026',
		dateRu: 'Май 2026',
		descriptionEng: "A calm landing page for a city library. The design presents books, events, services and contacts in a soft editorial style.",
		descriptionRu: "Спокойный лендинг для городской библиотеки. Дизайн показывает книги, события, услуги и контакты в мягкой editorial-подаче.",
		image: 'projects/library-landing.svg',
		tags: ['React', 'Vite', 'Tailwind CSS', 'Landing Page', 'Responsive', 'Editorial UI'],
		category: 'landing',
		github: "https://github.com/kenform/library-landing",
		webapp: "https://library-landing-iarsydf65-kenformgod-6184s-projects.vercel.app/",
	},
	{
		id: 8,
		title: 'Quiz',
		dateEng: 'Oct 2023',
		dateRu: 'Окт 2023',
		descriptionEng: "A small React quiz app that demonstrates basic interaction, user choice logic and state updates.",
		descriptionRu: "Небольшое React-приложение с квизом, которое показывает базовую интерактивность, логику выбора и обновление состояния.",
		image: 'projects/09.jpg',
		tags: ['Html', 'Scss', 'Javascript', 'React'],
		category: 'other',
		github: "https://github.com/kenform/Quiz",
		webapp: "https://kenform.github.io/Quiz/",
	},
	{
		id: 9,
		title: 'Modal',
		dateEng: 'Oct 2023',
		dateRu: 'Окт 2023',
		descriptionEng: "A compact UI component demo showing modal opening, closing and state control.",
		descriptionRu: "Компактный UI-demo проект с открытием, закрытием и управлением состоянием модального окна.",
		image: 'projects/10.jpg',
		tags: ['Html', 'Scss', 'Javascript', 'React'],
		category: 'other',
		github: "https://github.com/kenform/Modal",
		webapp: "https://kenform.github.io/Modal/",
	},
	{
		id: 10,
		title: 'Counter',
		dateEng: 'Oct 2023',
		dateRu: 'Окт 2023',
		descriptionEng: "A minimal React counter project focused on basic state logic.",
		descriptionRu: "Минимальный React-счётчик для демонстрации базовой работы с состоянием.",
		image: 'projects/11.jpg',
		tags: ['Html', 'Scss', 'Javascript', 'React'],
		category: 'other',
		github: "https://github.com/kenform/Counter",
		webapp: "https://kenform.github.io/Counter/",
	},
	{
		id: 11,
		title: 'Users',
		dateEng: 'Oct 2023',
		dateRu: 'Окт 2023',
		descriptionEng: "A small React app for loading, displaying and filtering user data.",
		descriptionRu: "Небольшое React-приложение для загрузки, отображения и фильтрации данных пользователей.",
		image: 'projects/12.jpg',
		tags: ['Html', 'Scss', 'Javascript', 'React'],
		category: 'other',
		github: "https://github.com/kenform/Users",
		webapp: "https://kenform.github.io/Users/",
	},
	{
		id: 12,
		title: 'currency-convertor',
		dateEng: 'Oct 2023',
		dateRu: 'Окт 2023',
		descriptionEng: "A practical currency converter mini app with API data and conversion logic.",
		descriptionRu: "Практичный мини-проект конвертера валют с данными из API и логикой пересчёта.",
		image: 'projects/13.jpg',
		tags: ['Html', 'Scss', 'Javascript', 'React'],
		category: 'other',
		github: "https://github.com/kenform/currency-convertor",
		webapp: "https://kenform.github.io/currency-convertor/",
	}

];
export const experiences = [
        {
                id: 0,
                img: '/favicon.svg',
                role: 'Frontend / Portfolio Developer',
                company: 'Personal portfolio and client-style projects',
                date: '2024 - Present',
                desc: 'Building and polishing responsive websites, landing pages and portfolio projects with a focus on clean UI, adaptive layouts, project presentation, GitHub workflow and deployment.',
                skills: ['React', 'JavaScript', 'HTML', 'CSS', 'SCSS', 'Tailwind', 'GitHub', 'Vercel', 'Responsive UI'],
        },
        {
                id: 1,
                img: '/favicon.svg',
                role: 'Website Modernization',
                company: 'Archived web projects',
                date: '2026',
                desc: 'Updated older projects, improved metadata, checked live links, polished project descriptions and prepared the portfolio to look like a clean showcase instead of a collection of unfinished practice tasks.',
                skills: ['SEO basics', 'Metadata', 'GitHub Pages', 'Build checks', 'UI polish', 'Project audit'],
        },
        {
                id: 2,
                img: '/favicon.svg',
                role: 'AI-assisted Web Workflow',
                company: 'Programming / Portfolio workflow',
                date: '2026',
                desc: 'Using AI-assisted development workflow for safer code reviews, small patches, build checks, commits and iterative website improvements.',
                skills: ['AI tools', 'Code review', 'Debugging', 'React', 'Automation', 'Deployment workflow'],
        },
];


export const education = [
        {
                id: 0,
                img: '/favicon.svg',
                school: 'Self-directed web development',
                date: 'Ongoing',
                grade: 'Practice-based learning',
                desc: 'Learning web development through real projects, portfolio improvements, UI polish, deployment, debugging and rebuilding older websites into a stronger showcase.',
                degree: 'Frontend Development / Web Design Practice',
        },
        {
                id: 1,
                img: '/favicon.svg',
                school: 'AI-assisted development workflow',
                date: 'Ongoing',
                grade: 'Project workflow',
                desc: 'Building a practical workflow around briefs, code review, safe patches, build checks, GitHub commits and deployment for client-ready websites.',
                degree: 'Practical AI + Web Development Workflow',
        },
];

